import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileExclamationTwoToneSvg from "@ant-design/icons-svg/es/asn/FileExclamationTwoTone";
import AntdIcon from "../components/AntdIcon";
var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExclamationTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FileExclamationTwoTone);